const SupportPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <h1 className="text-4xl font-outfit font-bold tracking-tight text-slate-900 mb-8">
          Support
        </h1>
        <div className="space-y-4">
          <p className="text-slate-600">Need help? Contact us:</p>
          <p className="text-slate-600">Email: support@dxb2bom.com</p>
          <p className="text-slate-600">Phone: +971-XXX-XXXX</p>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;